import { Product, StateHotbait } from '@omniafishing/core';
import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { getCategoryByName } from '../../categories_subcategories';
import { useListAttributionUuid } from '../../hooks/use_list_attribution_uuid';
import { getProductsByCategory } from '../../lib/products';
import { LINE_ATTRIBUTION } from '../../redux/cart';
import { getCategories } from '../../redux/reference_data';
import { ProductCarousel } from '../carousel/product_carousel';
import { ProductsGroupCard } from '../products_group_card/products_group_card';
import styles from './category_products_carousels.less';

interface CategoryProductsCarouselsProps {
  hotbaits: StateHotbait[];
  bestSellers: Product[];
  recommendations: Product[];
  stateAbbr: string;
  onTechniqueClick?: () => void;
  selectedTechniqueName: string;
}

export const CategoryProductsCarousels = (props: CategoryProductsCarouselsProps) => {
  const {
    hotbaits,
    bestSellers,
    recommendations,
    stateAbbr,
    onTechniqueClick,
    selectedTechniqueName,
  } = props;
  const allCategories = useSelector(getCategories);
  const list_uuid = useListAttributionUuid();

  const categories = [
    getCategoryByName(allCategories, 'jigs'),
    getCategoryByName(allCategories, 'softbaits'),
    getCategoryByName(allCategories, 'hardbaits'),
    getCategoryByName(allCategories, 'spinnerbaits'),
    getCategoryByName(allCategories, 'rigs'),
    getCategoryByName(allCategories, 'lines'),
    getCategoryByName(allCategories, 'accessories'),
    getCategoryByName(allCategories, 'terminal'),
    getCategoryByName(allCategories, 'rods'),
    getCategoryByName(allCategories, 'reels'),
    getCategoryByName(allCategories, 'apparel'),
  ];

  const hotbaitsSorted = _.orderBy(
    hotbaits,
    [
      (sh) => sh.fishing_reports.length,
      (sh) => sh.product.state_fishing_report_counters[stateAbbr],
    ],
    ['desc', 'desc']
  );

  const allProducts = [
    ...hotbaitsSorted.map((sh) => sh.product),
    ...bestSellers,
    ...recommendations,
  ];

  return (
    <>
      {categories.map((cat) => {
        const categoryProducts = getProductsByCategory(allProducts, cat.name);

        if (!categoryProducts.length) {
          return null;
        }

        const categoryProductsUniq = _.uniqBy(categoryProducts, 'sku');
        const categoryProductsGroup = _.groupBy(categoryProductsUniq, 'shopify_product_id');
        const productGroups = Object.values(categoryProductsGroup);

        const allProductsFlat = _.flatten(productGroups);

        return (
          <React.Fragment key={cat.name}>
            <div>
              <h3>
                {cat.display_name} ({allProductsFlat.length})
              </h3>
              <div className={styles.carousel}>
                <ProductCarousel
                  products={allProductsFlat}
                  arrows={true}
                  list_id_title={cat.display_name}
                  list_uuid={list_uuid}
                  fadedEdges
                >
                  {productGroups.map((productGroup, i) => {
                    const productSkus = productGroup.map((p) => p.sku);
                    const fishingReports = _.flatten(
                      hotbaits
                        .filter((hb) => productSkus.includes(hb.product.sku))
                        .map((hb) => hb.fishing_reports)
                    );

                    return (
                      <div key={productGroup[0].shopify_product_id} className={styles.card__2_6}>
                        <ProductsGroupCard
                          products={productGroup}
                          position={i}
                          fishingReports={fishingReports}
                          onTechniqueClick={() => {
                            onTechniqueClick?.();
                          }}
                          showTechniqueReported={selectedTechniqueName == null}
                          lineItemAttribution={[
                            {
                              key: LINE_ATTRIBUTION.STATE_ABBR,
                              value: stateAbbr,
                            },
                          ]}
                          list_uuid={list_uuid}
                        />
                      </div>
                    );
                  })}
                </ProductCarousel>
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </>
  );
};
